import './style';
import 'bootstrap/dist/js/bootstrap.bundle';
import {CopyFields} from './copy/copy-fields';
import {Sidebar} from './sidebar/sidebar';
import Choices from 'choices.js';

new CopyFields();
new Sidebar();

const elementsChoice = document.querySelectorAll('.js-choice');
for (const element of elementsChoice) {
  if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLSelectElement)) {
    continue;
  }

  const choiceElement = new Choices(element, {
    removeItemButton: true,
    allowHTML: false,
    addItemText: (value) => {
      return `Eingabetaste drücken, um "${value}" hinzuzufügen`;
    },
    itemSelectText: 'Zum Auswählen klicken',
  });

  if (element instanceof HTMLSelectElement) {
    const passedElement = choiceElement.passedElement.element;
    passedElement.addEventListener('change', function() {
      const placeholder = choiceElement.containerInner.element.querySelector('input[type=search]');

      if (placeholder instanceof HTMLInputElement) {
        if ('selectedOptions' in passedElement && passedElement.selectedOptions.length > 0) {
          placeholder.style.display = 'none';
        } else {
          placeholder.style.display = 'inline-block';
        }
      }
    });
  }
}
